export type IntervalDataType = 'MID' | 'MARK' | 'LAST';

export interface IntervalKey {
  symbol: string;
  intervalDataType: IntervalDataType;
  interval: '1' | '5' | '15' | '60' | '240' | '1D' | '1W';
}

export function intervalKeyToString({ symbol, intervalDataType, interval }: IntervalKey) {
  return [symbol, intervalDataType, interval].join(':');
}
